import { createI18n } from 'vue-i18n';

import enCommon from './locales/en/common.json';
import enUser from './locales/en/user.json';
import enMenu from './locales/en/menu.json';
import enTicket from './locales/en/ticket.json';
import enActivityLog from './locales/en/activityLog.json';
import enSetting from './locales/en/setting.json';

import thCommon from './locales/th/common.json';
import thUser from './locales/th/user.json';
import thMenu from './locales/th/menu.json';
import thTicket from './locales/th/ticket.json';
import thActivityLog from './locales/th/activityLog.json';
import thSetting from './locales/th/setting.json';

const savedLocale =
  JSON.parse(
    localStorage.getItem('language') || '{}'
  )?.initials?.toLowerCase() || 'en';

const messages = {
  en: {
    common: enCommon,
    user: enUser,
    menu: enMenu,
    ticket: enTicket,
    activityLog: enActivityLog,
    setting: enSetting,
  },
  th: {
    common: thCommon,
    user: thUser,
    menu: thMenu,
    ticket: thTicket,
    activityLog: thActivityLog,
    setting: thSetting,
  },
};

const i18n = createI18n({
  legacy: false,
  locale: savedLocale,
  fallbackLocale: 'en',
  messages,
});

export default i18n;
